import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';
import { HttpClient, HttpRequest, HttpResponseBase } from '@angular/common/http';
import { ContractTerm, PagedResults, PagerOptions } from 'src/app/app.types';
import { Observable } from 'rxjs';
import { stringifyPagerOptions } from 'src/util/http-helpers';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ContractTermService {
  apiUrl: string;

  constructor(private http: HttpClient,
    private configService: ConfigService) {
      this.apiUrl = `${this.configService.API_URI}/contractterm`;
  }
    
  getList(pagerOptions: PagerOptions): Observable<PagedResults<ContractTerm>>{
    const url = `${this.apiUrl}/${stringifyPagerOptions(pagerOptions)}`;

    return this.http.get<PagedResults<ContractTerm>>(url);
  }

  addNew(contractTerm: ContractTerm){
    const req = new HttpRequest("POST", this.apiUrl, contractTerm);

    return this.http.request<ContractTerm>(req)
      .pipe(filter(x => x instanceof HttpResponseBase));
  }

  edit(contractTerm: ContractTerm){
    const req = new HttpRequest("PUT", `${this.apiUrl}/${contractTerm.id}`, contractTerm);

    return this.http.request<ContractTerm>(req)
      .pipe(filter(x => x instanceof HttpResponseBase));
  }

  delete(contractTerm: ContractTerm){
    const req = new HttpRequest("DELETE", `${this.apiUrl}/${contractTerm.id}`);

    return this.http.request<ContractTerm>(req)
      .pipe(filter(x => x instanceof HttpResponseBase));
  }
}
